module.exports = __webpack_public_path__ + "static/media/GetInTouch.cb1009cf.svg";